import {ALERT_SHOW} from "@/store/actions/alert";

import counterInstallationPlaceAPI from "@/utils/axios/counter_installation_place"
import {
    CREATE_COUNTER_INSTALLATION_PLACE,
    DELETE_COUNTER_INSTALLATION_PLACE,
    GET_ALL_COUNTER_INSTALLATION_PLACES,
    SELECT_COUNTER_INSTALLATION_PLACE,
    UPDATE_COUNTER_INSTALLATION_PLACE
} from "@/store/actions/counter_installation_place";
import {START_MODAL_LOADING, STOP_MODAL_LOADING} from "@/store/actions/loading";

const state = {
    counter_installation_places: [],
    select_counter_installation_places: [],
    select_loaded: false
}

const getters = {
    getCounterInstallationPlaces: state => state.counter_installation_places,
    getSelectCounterInstallationPlaces: state => state.select_counter_installation_places,
}

const actions = {
    [GET_ALL_COUNTER_INSTALLATION_PLACES]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            counterInstallationPlaceAPI.get_all(payload)
                .then(response => response.data)
                .then(data => {
                    commit(GET_ALL_COUNTER_INSTALLATION_PLACES, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
        })
    },
    [CREATE_COUNTER_INSTALLATION_PLACE]: ({ dispatch, commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            counterInstallationPlaceAPI.create(payload)
                .then(response => response.data)
                .then(data => {
                    commit(CREATE_COUNTER_INSTALLATION_PLACE, data)
                    dispatch(SELECT_COUNTER_INSTALLATION_PLACE)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [UPDATE_COUNTER_INSTALLATION_PLACE]: ({ commit }, payload) => {
        commit(START_MODAL_LOADING)
        return new Promise((resolve, reject) => {
            counterInstallationPlaceAPI.update(payload)
                .then(response => response.data)
                .then(data => {
                    commit(UPDATE_COUNTER_INSTALLATION_PLACE, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [DELETE_COUNTER_INSTALLATION_PLACE]: ({ dispatch, commit }, payload) => {
        return new Promise((resolve, reject) => {
            commit(START_MODAL_LOADING)
            counterInstallationPlaceAPI.remove(payload)
                .then(response => response.data)
                .then(data => {
                    commit(DELETE_COUNTER_INSTALLATION_PLACE, data)
                    dispatch(SELECT_COUNTER_INSTALLATION_PLACE)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
                .finally(() => commit(STOP_MODAL_LOADING))
        })
    },
    [SELECT_COUNTER_INSTALLATION_PLACE]: ({ commit }, payload) => {
        return new Promise((resolve, reject) => {
            counterInstallationPlaceAPI.select(payload)
                .then(response => response.data)
                .then(data => {
                    commit(SELECT_COUNTER_INSTALLATION_PLACE, data)
                    resolve(true)
                })
                .catch(err => {
                    const error = err.response.data.detail;
                    commit(ALERT_SHOW, { text: error, color: 'error lighten-1' })
                    reject(false)
                })
        })
    },
}

const mutations = {
    [GET_ALL_COUNTER_INSTALLATION_PLACES]: (state, payload) => {
        state.counter_installation_places = payload
    },
    [CREATE_COUNTER_INSTALLATION_PLACE]: (state, payload) => {
        state.counter_installation_places.push(payload)
    },
    [UPDATE_COUNTER_INSTALLATION_PLACE]: (state, payload) => {
        let obj = state.counter_installation_places.find(item => item.id === payload.id)
        Object.keys(payload).forEach(item => {
            obj[item] = payload[item]
        })
    },
    [DELETE_COUNTER_INSTALLATION_PLACE]: (state, payload) => {
        const obg = state.counter_installation_places.find(item => item.id === payload.id)
        const obj_id = state.counter_installation_places.indexOf(obg)
        if (obg) {
            state.counter_installation_places.splice(obj_id, 1)
        }
    },
    [SELECT_COUNTER_INSTALLATION_PLACE]: (state, payload) => {
        state.select_counter_installation_places = payload
        state.select_loaded = true
    },
}

export default {
    state,
    getters,
    actions,
    mutations
}